<template>
  <el-row
    class="programs-subheader"
    type="flex"
    justify="middle"
  >
    <h3 class="programs-subheader__subtitle">
      <app-i18n :code="i18nCode" />
      <span v-text="`(${amount})`" />
    </h3>
  </el-row>
</template>

<script>
export default {
  name: 'programs-subheader',
  props: {
    amount: Number,
    i18nCode: String,
  },
}
</script>

<style lang="scss" scoped>
.programs-subheader {
  height: 85px;
  border-bottom: 2px solid #f7f7f7;

  &__subtitle {
    @include layout-container;

    display: flex;
    align-items: center;
    padding-left: var(--mobile-header-padding);

    span {
      margin-right: 5px;
      font-size: 22px;
      font-weight: 500;
      font-style: normal;
      color: #4c4c4c;
    }
  }
}
</style>
